





























































import {Component} from 'vue-property-decorator';

import Menu from '../components/Menu.vue';
import Footer from '@/components/Footer.vue';
import MainImage from '@/components/MainImage.vue';
import {Mixins} from 'vue-mixin-decorator';
import PageVue from '@/script/PageVue';
import ImageManager from '@/script/ImageManager';
import TextManager from '@/script/TextManager';
import {loadYaml} from '@/script/common';

@Component({
  components: {MainImage, Footer, Menu },
})
export default class Announcement02Page extends Mixins<PageVue>(PageVue) {
  private scheduleList: any[] = [];

  private async mounted() {
    this.scheduleList = await loadYaml('config/schedule.yaml');
  }

  private getRowSpan(idx: number): number {
    if (idx === this.scheduleList.length - 1) {
      return 1;
    }
    let count: number = 1;
    const s1 = this.scheduleList[idx];
    if (idx > 0) {
      const s2 = this.scheduleList[idx - 1];
      if (s1.date === s2.date) {
        return 1;
      }
    }
    for (let i = idx + 1; i < this.scheduleList.length; i++) {
      const s2 = this.scheduleList[i];
      if (s1.date === s2.date) {
        count++;
      } else {
        break;
      }
    }
    return count;
  }
}
